import React, { useContext } from 'react';
import { Link, navigate, useLocation } from '@reach/router';
import { NavTab, TabsOrientation } from 'react-magma-dom';
import { NAV_LIST_MAP, NOT_FOUND } from '../../constants';
import { EditToolContext } from '../../contexts/editToolContext';

interface INavElement {
  direction: string;
  current: string;
}

export const NavElement: React.FC<INavElement> = (props: INavElement): JSX.Element => {
  const { direction, current } = props;

  const { pathname } = useLocation();

  const { handleLeavePage } = useContext(EditToolContext);

  const toUrl = direction.replace(/ /g, '-');
  const isActive = pathname !== `/${NOT_FOUND}` && direction === current.replace(/-/g, ' ');

  return (
    <NavTab
      orientation={TabsOrientation.horizontal}
      isActive={isActive}
      onClick={e => handleLeavePage(() => navigate(`/${toUrl}`), false, e)}
      component={<Link to={toUrl}>{NAV_LIST_MAP[direction] ?? direction}</Link>}
    />
  );
};
